// feature-announcements.ts
export interface FeatureAnnouncement {
  id: string;
  cutoff: Date;
}

export const FEATURE_ANNOUNCEMENTS: FeatureAnnouncement[] = [
  { id: 'help-page-2026', cutoff: new Date('2026-09-10T00:00:00Z') },
  // add future announcements here
];